import type { DtiRender } from "../../../lib/agent-types";
import { capDtiRatio } from "../../../lib/financials";
import { ProgressBar } from "../../ui/feedback";
import { WidgetFrame, WidgetPlaceholderRow } from "../widget-frame";

function formatRatio(value: number | null | undefined): string {
  if (typeof value !== "number") return "—";
  return `${(value * 100).toFixed(1)}%`;
}

export function DtiWidget({ payload }: { payload: DtiRender }) {
  const qualification = payload.estimate.results[0]?.raw.qualification;
  const backEnd = capDtiRatio(qualification?.back_end_dti);
  const maxDti = capDtiRatio(qualification?.max_back_end_dti);
  const overBy =
    typeof backEnd === "number" &&
    typeof maxDti === "number" &&
    backEnd > maxDti
      ? backEnd - maxDti
      : null;
  const progress =
    typeof backEnd === "number" && typeof maxDti === "number" && maxDti > 0
      ? Math.min(100, (backEnd / maxDti) * 100)
      : null;

  return (
    <WidgetFrame data-widget-type="dti">
      <WidgetPlaceholderRow
        label="Estimated DTI"
        value={formatRatio(backEnd)}
      />
      <WidgetPlaceholderRow
        label="Typical DTI limit"
        value={formatRatio(maxDti)}
      />
      {progress !== null ? (
        <ProgressBar className="mt-3" value={progress} />
      ) : null}
      {overBy !== null ? (
        <p className="mt-2 rounded-2xl bg-destructive/10 px-3 py-2 text-xs text-destructive">
          This is {formatRatio(overBy)} above a typical DTI limit.
        </p>
      ) : null}
    </WidgetFrame>
  );
}
